import { createSlice } from '@reduxjs/toolkit';
import { ConvertToAccessInternal } from 'Utils/Helpers/AccessConvert';
import { read, store } from 'Utils/Helpers/LocalStorage';
import { storeToken } from 'Utils/Helpers/Token';

const staffSlice = createSlice({
    name : 'staff',
    initialState : {
        total: null,
        current: [],
    },
    reducers : {
        setSystemUsers: (state , action) => {
            if(action.payload.users.length !== 0) {
                const users = action.payload.users;
                state.total = users;
                if(users.filter(i => i.id === read('local'))[0]) {
                    const user = users.filter(i => i.id === read('local'))[0];
                    state.current = ConvertToAccessInternal(user.access);
                } else {
                    state.current = ConvertToAccessInternal(read('access'), false);
                }
            } else {
                state.total = [];
                state.current = ConvertToAccessInternal(read('access'), false);
            }
        },
        changeDoctors: (state , action) => {
            state.total[action.payload.index].doctor = action.payload.status;
        },
    }
})

export const { setSystemUsers, changeDoctors } = staffSlice.actions;

export default staffSlice.reducer;